import React from 'react';
import { Tracking, TrackingProvider } from '@expert360/tracking';
import FeedbackContext from 'core/context/feedback';
import RelayEnvironmentContext from 'core/context/relayEnvironment';
import {
  FeatureFlagContainer,
  ConfigProvider,
  FeatureFlagProvider,
} from 'utils';

const Providers = ({
  children,
  config,
  user,
  flags,
  renderFeedback,
  relayEnvironment,
}) => {
  const trackingInstance = new Tracking({
    segment: {
      apiKey: config.SEGMENT_API_KEY,
      options: {
        integrations: {
          FullStory: /^(?!\/admin)/i.test(window.location.pathname),
        },
      },
    },
    isImpersonating: user?.isImpersonating ?? false,
    user: user || {},
  });

  const featureFlagContainer = new FeatureFlagContainer(flags);

  return (
    <TrackingProvider instance={trackingInstance}>
      <FeatureFlagProvider.Provider value={featureFlagContainer}>
        <ConfigProvider config={config}>
          <FeedbackContext.Provider value={renderFeedback}>
            <RelayEnvironmentContext.Provider
              value={{
                relayEnvironment,
              }}
            >
              {children}
            </RelayEnvironmentContext.Provider>
          </FeedbackContext.Provider>
        </ConfigProvider>
      </FeatureFlagProvider.Provider>
    </TrackingProvider>
  );
};

export default Providers;
